import { Button, Input, Select } from '@/components';
import { MasterInfoEnum, ROUTERS } from '@/constant';
import { memo, useCallback } from 'react';

import AutoComplete from '../form/auto-complete';
import {
	SearchType,
	TYPE_SEARCH_FRANCHISE_OPTIONS,
	TYPE_SEARCH_FRANCHISE_OPTIONS_BM1_03,
} from './config';
import { TFilter } from './type';

export type TFormSearchAssignment = {
	filter: TFilter;
	handleChangeSelect: (value: string) => void;
	handleChangeKeyword: (e: React.ChangeEvent<HTMLInputElement>) => void;
	handleSelectMasterInfo: (value: string) => void;
	onSearch: () => void;
	openFrom?: string;
};

const FormSearchAssignment = ({
	filter,
	handleChangeSelect,
	handleChangeKeyword,
	handleSelectMasterInfo,
	onSearch,
	openFrom,
}: TFormSearchAssignment) => {
	const handleKeyDown = useCallback(
		(e: React.KeyboardEvent<HTMLInputElement>) => {
			if (e.key === 'Enter') {
				onSearch();
			}
		},
		[onSearch]
	);

	return (
		<div className="grid pt-5 grid-cols-3">
			<div className="col-span-2 grid grid-cols-3">
				<div className={'flex flex-row items-center col-span-2 gap-2'}>
					<Select
						value={filter.valueSelect}
						options={
							openFrom === ROUTERS.BM1_03 || openFrom === ROUTERS.BM1_01
								? TYPE_SEARCH_FRANCHISE_OPTIONS_BM1_03
								: TYPE_SEARCH_FRANCHISE_OPTIONS
						}
						onChange={handleChangeSelect}
					/>
					{filter.valueSelect === SearchType.FRANCHISE_ADDRESS ? (
						<Input
							value={filter.keyword}
							onChange={handleChangeKeyword}
							inputClassName="w-[250px]"
							onPressEnter={onSearch}
						/>
					) : (
						<AutoComplete
							onChange={handleSelectMasterInfo}
							type={
								filter.valueSelect === SearchType.APPLICANT_NAME
									? MasterInfoEnum.AUTOCOMPLETE_APPLICANT_NAME
									: MasterInfoEnum.AUTOCOMPLETE_FRANCHISE_EMPLOYER_NAME
							}
							value={filter.keyword}
							containerClassName="w-[250px]"
							placeholder="선택"
							onKeyDown={handleKeyDown}
						/>
					)}

					<Button secondary onClick={onSearch}>
						검색
					</Button>
				</div>
			</div>
		</div>
	);
};

export default memo(FormSearchAssignment);
